import React, { createContext, useContext, useState } from "react";

const SearchModeContext = createContext();

export const useSearchMode = () => {
  const context = useContext(SearchModeContext);
  if (!context) {
    throw new Error("useSearchMode must be used within a SearchModeProvider");
  }
  return context;
};

export const SearchModeProvider = ({ children }) => {
  const [searchMode, setSearchMode] = useState("companies"); // "companies", "people", or "mpc"

  return (
    <SearchModeContext.Provider
      value={{
        searchMode,
        setSearchMode,
      }}
    >
      {children}
    </SearchModeContext.Provider>
  );
};
